import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

function NavBar() {
  return (
    <div className={'background'}>
     <Navbar key={'lg'} bg="transparent" expand={'lg'} className="mb-3 navbar-fixed-top navbar" fixed="top">
          <Container fluid style={{marginRight: '50px', marginLeft: '50px'}}>
            <Navbar.Brand href="/"><span style={{wordSpacing: '0.5px', fontSize: '20px'}}>DyslexiHelp</span>  </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${'lg'}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${'lg'}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${'lg'}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${'lg'}`}/>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                <Nav.Link className={'nav-item'} href="/tts"><span style={{wordSpacing: '0.5px', fontSize: '18px', color: 'black'}}>Text Reader</span></Nav.Link>
                  <Nav.Link className={'nav-item'} href="/summarize"><span style={{fontSize: '18px',color: 'black'}}>Summarize</span></Nav.Link>
                  <Nav.Link className={'nav-item'} href="/hemingway"><span style={{fontSize: '18px',color: 'black'}}>Hemingway</span> </Nav.Link>
                  <Nav.Link className={'nav-item'} href="#action2"><span style={{fontSize: '18px',color: 'black'}}>Education</span> </Nav.Link>
                  {/* <Nav.Link href="#action2">Tests</Nav.Link> */}
                  {/* <NavDropdown
                    title="Tools"
                    id={`offcanvasNavbarDropdown-expand-${'lg'}`}
                  >
                    <NavDropdown.Item href="#action3">Text to Speech</NavDropdown.Item>
                    <NavDropdown.Item href="#action4">
                      Summarize
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="#action5">
                        Hemingway
                    </NavDropdown.Item>
                  </NavDropdown> */}
                </Nav>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
    </div>
  );
}

export default NavBar;